import classNames from "classnames";
import { PageNav } from "@ugg/shared/components/common/PageNav";
import { AppRoutes, getLeaderboardChampionRanking } from "@ugg/shared/routes/app-routes";

export function LeaderboardNav({ className }: { className?: string }) {
  const tabs = [
    { to: AppRoutes.LEADERBOARD_RANKING, label: "Players", reset: true },
    { to: getLeaderboardChampionRanking(), label: "Champions" },
  ];

  return (
    <div className={classNames(className)}>
      <PageNav tabs={tabs} />
    </div>
  );
}
